import {
    serverBus
} from '@/main'
import Global from '@/scripts/Global'
import SessionManager from '@/Manager/Session.manager'
import FileApi from '@/scripts/api/file.api'
import VueSignals from '@/scripts/VueSignals'
import config from '@/scripts/config'

export default {
    name: 'FileDetails',
    data: function() {
        return {
            modified_user: null,
            showContextMenu: '',
            fileViewSrc: '',
            openInBrowser: false,
            donwload_file: false,
        }
    },
    mounted() {
        document.querySelector(".right-sidebar-holder").scrollTop = 0
        this.modified_user = this.getUser(this.file_doc.changed_by_user)

        serverBus.$on(VueSignals.HIDE_CONTEXT_MENU, (data) => {
            this.showContextMenu = ''
        })
    },
    props: {
        file_doc: {
            type: Object,
            required: true
        },
        folder_id: {
            type: String,
            required: true
        },
    },
    methods: {
        ViewCollabora(file_id, name, folder_id) {
            FileApi.downloadFile(file_id, name, folder_id).then(res => {
                if (res.data.result) {
                    FileApi.ViewFile(res.data.token_id).then(res => {
                        if (res.data.result) {
                            this.fileViewSrc = res.data.link
                            var win = window.open(res.data.link)
                            win.focus()
                        }
                    })
                }
            })
        },
        EditCollabora(file_id, name, folder_id) {
            FileApi.downloadFile(file_id, name, folder_id).then(res => {
                if (res.data.result) {
                    FileApi.EditFile(res.data.token_id).then(res => {
                        if (res.data.result) {
                            var win = window.open(res.data.link)
                            win.focus()
                        }
                    })
                }
            })
        },
        getFileExtension(filename) {
            return Global.getFileIcon(filename)
        },
        toByte(item) {
            if (item.file_size_b != 0) {
                return Global.toByte(item.file_size_b)
            }
            return Global.toByte(item.file_size_kb_estimate, 1)
        },
        getUser(user_id) {
            if (user_id && user_id != null) {
                return SessionManager.getUser(user_id)
            }
            return null
        },
        DownloadFile(file_id, file_name) {
            if (Global.isMobileClientUsed()) {
                // Xamarin function C#
                try {
                    window.top.invokeCSharpOpenDocument(this.folder_id, file_id, file_name);
                } catch(err) {
                }
            } else {
                FileApi.downloadFile(file_id, file_name, this.folder_id).then(res => {
                    if (typeof res.data.link != 'undefined') {
                        let file_path = res.data.link
                        var a = document.createElement('A');
                        a.href = file_path;
                        a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
                        document.body.appendChild(a);
                        a.click()
                    }
                })
            }
        },
        FilePreview(file_id) {
            FileApi.Preview(file_id).then(res => {
                if (typeof res.data != 'undefined' && res.data.result) {
                    let img = document.createElement("img")
                    img.classList = "img-preview"
                    img.id = 'img_' + file_id + "_preview"
                    img.src = "data:image/jpeg;base64," + res.data.data
                    if (document.getElementById('img_' + file_id + "_preview") == null) {
                        document.getElementById("imgPreview").appendChild(img)
                    }
                }
            }).catch(err => {
                console.log(err)
            })
        },
        ViewOffice(file_id, file_name, folder_id) {
            FileApi.getOffice(file_id, file_name, folder_id).then(res => {
                if (res.data.result) {
                    window.open(res.data.link, '_blank').focus()
                }
            })
        },
        Mention(ff_id, ff_name, ff_type) {
            Global.globalValue(VueSignals.MENTION_FILE, {
                "ff_id": ff_id,
                "ff_name": ff_name,
                "ff_type": ff_type,
            })
            Global.globalValue(VueSignals.HIDE_CONTEXT_MENU, true)
        },
        RenameOverlay(ff_id, ff_name, ff_type) {
            Global.globalValue(VueSignals.HIDE_CONTEXT_MENU, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'rename_ff')
            Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {
                'ff_name': ff_name,
                'ff_id': ff_id,
                'ff_type': ff_type
            })
        },
        DeleteOverlay(ff_id, ff_name) {
            Global.globalValue(VueSignals.HIDE_CONTEXT_MENU, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'confirm_delete')
            Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {
                'ff_name': ff_name,
                'ff_id': ff_id
            })
        },
        ShowContextMenu(cp_id) {
            this.showContextMenu = cp_id
        },
        ExternalLinks(ff_id, ff_name, ff_type) {
            Global.globalValue(VueSignals.SHOW_EXTERNAL_LINK_FOR, {
                'ff_id': ff_id,
                'ff_name': ff_name,
                'ff_type': ff_type
            })
        },
        SupportedByBrowser(file_name) {
            if (Global.isMobileClientUsed()) {
                // Don't display in the app
                return false;
            } else {
                for (let i = 0; i < config.SUPPORTED_OPEN_IN_BROWSER.length; i++) {
                    if (file_name.toLowerCase().endsWith(config.SUPPORTED_OPEN_IN_BROWSER[i])) {
                        return true
                    }
                }
                return false
            }
        },
        OpenBrowser(file_id, file_name) {
            Global.globalValue(VueSignals.OPEN_FILE_IN_BROWSER, {
                'file_id': file_id,
                'file_name': file_name
            })
        }
    }
}
